<template>
	<div
		class="flex-grow bg-white shadow-md rounded border-gray-300 border"
		:class="checkIsDatTable ? 'bg-gray-200' : ''"
		v-if="!checkIsARentalCarSelected || (checkIsARentalCarSelected && checkIfActiveCard)"
	>
		<div class="text-left p-4">
			<table class="min-w-full divide-y" :class="checkIsDatTable ? 'bg-gray-200' : 'divide-gray-200'">
				<thead>
					<tr class="text-gray-500">
						<th class="py-2 bg-gray-50 text-left text-sm leading-4 font-medium uppercase tracking-wider px-3 w-1/4">
							{{ $t('class') }} {{ priceItem.car_class ? priceItem.car_class : parseInt(classIndex) + 1 }}
						</th>
						<th class="py-2 bg-gray-50 text-left text-sm leading-4 font-medium uppercase tracking-wider px-3 w-1/4">
							{{ $t('one_day_price') }}
						</th>
						<th class="py-2 bg-gray-50 text-left text-sm leading-4 font-medium uppercase tracking-wider px-3 w-1/4">{{ $t('three_day_price') }}</th>
						<th class="py-2 bg-gray-50 text-left text-sm leading-4 font-medium uppercase tracking-wider px-3 w-1/4">{{ $t('seven_day_price') }}</th>
					</tr>
				</thead>
				<tbody class="bg-white divide-y" :class="checkIsDatTable ? 'bg-gray-200' : 'divide-gray-200'">
					<tr>
						<td class="px-3 py-2 whitespace-no-wrap"></td>
						<td class="px-3 py-2 text-left whitespace-no-wrap">
							<BaseInputNumber
								ref="BaseInput.priceOneDay"
								v-if="isEditable"
								:required="true"
								v-model="priceItem.price_one_day"
								:error-message="$t('required_value')"
								@input="$emit('input')"
								:precision="2"
							></BaseInputNumber>
							<span v-if="!isEditable">{{ formatPrice(priceItem.price_one_day) }}</span>
						</td>
						<td class="px-3 py-2 text-left whitespace-no-wrap">
							<BaseInputNumber
								ref="BaseInput.priceThreeDays"
								v-if="isEditable"
								:required="true"
								v-model="priceItem.price_three_days"
								:error-message="$t('required_value')"
								@input="$emit('input')"
								:precision="2"
							></BaseInputNumber>
							<span v-if="!isEditable">{{ formatPrice(priceItem.price_three_days) }}</span>
						</td>
						<td class="px-3 py-2 text-left whitespace-no-wrap">
							<BaseInputNumber
								ref="BaseInput.priceSevenDays"
								v-if="isEditable"
								:required="true"
								v-model="priceItem.price_seven_days"
								:error-message="$t('required_value')"
								@input="$emit('input')"
								:precision="2"
							></BaseInputNumber>
							<span v-if="!isEditable">{{ formatPrice(priceItem.price_seven_days) }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber';
import Validate from '@/mixins/Validate';

export default {
	name: 'RentalCarRepairShopPricingCard',
	mixins: [Validate],
	components: { BaseInputNumber },
	props: {
		isARentalCarSelected: {},
		priceItem: {},
		isEditable: {},
		isDatTable: {},
		classIndex: null,
		isActiveCard: { default: false },
	},
	computed: {
		checkIfActiveCard() {
			return this.isActiveCard;
		},
		checkIsDatTable() {
			return this.isDatTable && !this.isEditable;
		},
		checkIsARentalCarSelected() {
			return this.isARentalCarSelected;
		},
	},
	methods: {
		formatPrice(price) {
			return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, style: 'currency', currency: 'EUR' }).format(price / 100);
		},
	},
};
</script>

<style scoped>
.blue-card {
	background-color: #0068b4;
	color: #ffffff;
}
.form-group {
	margin: 0;
}
</style>
